/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClubeControllerVitrineParams,
  ErroResponse,
  ResgateResponse,
  VitrineDoClubeResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getClubeControllerVitrineUrl = (params?: ClubeControllerVitrineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/clube?${stringifiedParams}` : `/v1/clube`
}

/**
 * @summary Ranque do ambiente + cupons liberados para ele, com as categorias
 */
export const clubeControllerVitrine = async (params?: ClubeControllerVitrineParams, options?: Parameters<typeof httpClient>[1]): Promise<VitrineDoClubeResponse> => {

  return httpClient<VitrineDoClubeResponse>(getClubeControllerVitrineUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getClubeControllerVitrineQueryKey = (params?: ClubeControllerVitrineParams,) => {
    return [
    `/v1/clube`, ...(params ? [params] : [])
    ] as const;
    }


export const getClubeControllerVitrineQueryOptions = <TData = Awaited<ReturnType<typeof clubeControllerVitrine>>, TError = ErroResponse>(params?: ClubeControllerVitrineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clubeControllerVitrine>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClubeControllerVitrineQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clubeControllerVitrine>>> = ({ signal }) => clubeControllerVitrine(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clubeControllerVitrine>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClubeControllerVitrineQueryResult = NonNullable<Awaited<ReturnType<typeof clubeControllerVitrine>>>
export type ClubeControllerVitrineQueryError = ErroResponse


export function useClubeControllerVitrine<TData = Awaited<ReturnType<typeof clubeControllerVitrine>>, TError = ErroResponse>(
 params: undefined |  ClubeControllerVitrineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clubeControllerVitrine>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clubeControllerVitrine>>,
          TError,
          Awaited<ReturnType<typeof clubeControllerVitrine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClubeControllerVitrine<TData = Awaited<ReturnType<typeof clubeControllerVitrine>>, TError = ErroResponse>(
 params?: ClubeControllerVitrineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clubeControllerVitrine>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clubeControllerVitrine>>,
          TError,
          Awaited<ReturnType<typeof clubeControllerVitrine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClubeControllerVitrine<TData = Awaited<ReturnType<typeof clubeControllerVitrine>>, TError = ErroResponse>(
 params?: ClubeControllerVitrineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clubeControllerVitrine>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ranque do ambiente + cupons liberados para ele, com as categorias
 */

export function useClubeControllerVitrine<TData = Awaited<ReturnType<typeof clubeControllerVitrine>>, TError = ErroResponse>(
 params?: ClubeControllerVitrineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clubeControllerVitrine>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClubeControllerVitrineQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getClubeControllerResgatarUrl = (id: string,) => {




  return `/v1/clube/cupons/${id}/resgatar`
}

/**
 * @summary Registra o resgate do cupom por este ambiente
 */
export const clubeControllerResgatar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ResgateResponse> => {

  return httpClient<ResgateResponse>(getClubeControllerResgatarUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getClubeControllerResgatarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clubeControllerResgatar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof clubeControllerResgatar>>, TError,{id: string}, TContext> => {

const mutationKey = ['clubeControllerResgatar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clubeControllerResgatar>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  clubeControllerResgatar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClubeControllerResgatarMutationResult = NonNullable<Awaited<ReturnType<typeof clubeControllerResgatar>>>

    export type ClubeControllerResgatarMutationError = ErroResponse

    /**
 * @summary Registra o resgate do cupom por este ambiente
 */
export const useClubeControllerResgatar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clubeControllerResgatar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clubeControllerResgatar>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getClubeControllerResgatarMutationOptions(options), queryClient);
    }
